import IcoIdenticon from './IcoIdenticon.vue'

export { IcoIdenticon }
export default IcoIdenticon
